import React from "react";
import { Props } from "./types";

function AddIcon({ className }: Props) {
  const [isHovered, setIsHovered] = React.useState(false);

  return isHovered ? (
    <svg
      viewBox="0 0 47.327 38.141"
      className={className}
      onMouseLeave={() => setIsHovered(false)}
    >
      <g fill="none" stroke="#FF8E43FF" strokeWidth="2" strokeDasharray="5">
        <ellipse cx="19.152" cy="18.48" rx="19.152" ry="18.48" stroke="none" />
        <ellipse cx="19.152" cy="18.48" rx="18.152" ry="17.48" fill="none" />
      </g>
      <path
        d="M9.374,0A9.374,9.374,0,1,1,0,9.374,9.374,9.374,0,0,1,9.374,0Z"
        transform="translate(28.58 17.962)"
        stroke="none"
        fill="#FF8E43FF"
      />
      <text
        transform="translate(33.771 33.141)"
        fill="#fff"
        fontSize="18"
        fontFamily="ProximaNova-Bold, Proxima Nova"
        fontWeight="700"
        stroke="none"
        letterSpacing="-0.024em"
      >
        <tspan x="0" y="0">
          +
        </tspan>
      </text>
      <path
        d="M20.978,19.147V6.331A1.836,1.836,0,0,0,19.147,4.5H6.331A1.836,1.836,0,0,0,4.5,6.331V19.147a1.836,1.836,0,0,0,1.831,1.831H19.147A1.836,1.836,0,0,0,20.978,19.147ZM9.535,14.112l2.289,2.756,3.2-4.129,4.12,5.493H6.331Z"
        transform="translate(6.413 6.162)"
        stroke="none"
        fill="#FF8E43FF"
      />
      <circle
        cx="1.5"
        cy="1.5"
        r="1.5"
        transform="translate(21.664 14.141)"
        stroke="none"
        fill="#fff"
      />
    </svg>
  ) : (
    <svg
      viewBox="0 0 47.327 38.141"
      className={className}
      onMouseEnter={() => setIsHovered(true)}
    >
      <g fill="none" strokeWidth="2" strokeDasharray="5">
        <ellipse cx="19.152" cy="18.48" rx="19.152" ry="18.48" stroke="none" />
        <ellipse cx="19.152" cy="18.48" rx="18.152" ry="17.48" fill="none" />
      </g>
      <path
        d="M9.374,0A9.374,9.374,0,1,1,0,9.374,9.374,9.374,0,0,1,9.374,0Z"
        transform="translate(28.58 17.962)"
        stroke="none"
        fill="#b9b9b9"
      />
      <text
        transform="translate(33.771 33.141)"
        fill="#fff"
        fontSize="18"
        fontFamily="ProximaNova-Bold, Proxima Nova"
        fontWeight="700"
        stroke="none"
        letterSpacing="-0.024em"
      >
        <tspan x="0" y="0">
          +
        </tspan>
      </text>
      <path
        d="M20.978,19.147V6.331A1.836,1.836,0,0,0,19.147,4.5H6.331A1.836,1.836,0,0,0,4.5,6.331V19.147a1.836,1.836,0,0,0,1.831,1.831H19.147A1.836,1.836,0,0,0,20.978,19.147ZM9.535,14.112l2.289,2.756,3.2-4.129,4.12,5.493H6.331Z"
        transform="translate(6.413 6.162)"
        stroke="none"
      />
      <circle
        cx="1.5"
        cy="1.5"
        r="1.5"
        transform="translate(21.664 14.141)"
        stroke="none"
        fill="#fff"
      />
    </svg>
  );
}

export { AddIcon };
